import Route from '@ember/routing/route';
import { service } from '@ember/service';

import window from 'ember-window-mock';

import { jsURL } from 'register-partners-js/constants/hosts';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { fetchNavigationOrganizations } from 'register-partners-js/utils/fetch-navigation-organizations';

export default class RegistrationAlmostReadyRoute extends Route {
  mainLayout = MainLayout;

  @service store;
  @service networkManager;
  @service router;

  async redirect(model) {
    if (model.status === 'completed') {
      let organizationID = model.belongsTo('organization').id();
      let organizations = await fetchNavigationOrganizations(this.networkManager);
      let organization = organizations.find(org => org.id === organizationID);
      window.location.href = `${jsURL}/organizations/${organization.slug}`;
    }
    if (model.prepaidSource) {
      return this.router.transitionTo('registration.kyc');
    }
    // FIXME Temporary removal of the redirection to Embed Onboarding for company_creation flow to avoid blocking users
    //  during onboarding. Notion:
    //  https://www.notion.so/Payout-customers-hitting-a-blank-page-during-the-onboarding-26c31ee4c69680ec9c86d6f646529ef6?source=copy_link
    // else if (model.isEmbedded) {
    //  window.location.replace(`${embedOnboardingURL}/${model.id}`);
    // }
  }
}
